import apiProxy from './api-proxy-inst';

class ProductApi {
  deleteProduct(args) {
    return apiProxy.request('/erpapp_product/delete', args).then(data => {
      return data;
    });
  }

  putOnProduct(args) {
    return apiProxy.request('/erpapp_product_shelf/put_on', args).then(data => {
      return data;
    });
  }

  putOffProduct(args) {
    return apiProxy.request('/erpapp_product_shelf/put_off', args).then(data => {
      return data;
    });
  }

  addNewProduct(args) {
    return apiProxy.request('/erpapp_product/add', args).then(data => {
      return data;
    });
  }

  modifyProduct(args) {
    return apiProxy.request('/erpapp_product/modify', args).then(data => {
      return data;
    });
  }

  productList(args) {
    return apiProxy.request('/erpapp_product/list', args).then(data => {
      return data;
    });
  }
}

export default new ProductApi();